var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.627 10.512c0-5.337-4.375-9.618-9.755-9.618-5.625 0-9.96 4.187-9.96 9.645 0 4.053 2.365 7.423 5.857 8.908-.259.375-2.514 3.532-5.68 4.107 0 0 6.644 1.926 11.237-3.384 4.741-.67 8.301-4.656 8.301-9.658z",
    fill: "#FF2391"
  })));
}
export default SvgLoanLogo;